import React, { useEffect } from "react";
import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { FaTruckMoving, FaFile, FaPlusCircle, FaUserAlt } from "react-icons/fa";
import { AiFillFormatPainter } from "react-icons/ai";
import useApi from "../hooks/useApi";
import apiClient from "../api/apiClient";
export default ({ user, vehicle }) => {
  const [file, setfile] = useState(require("../assets/img/account-icon.png"));
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const mobileWidth = 576; // Define your mobile width threshold
      setIsMobile(window.innerWidth < mobileWidth);
    };

    handleResize(); // Initial check

    // Attach the resize event listener
    window.addEventListener("resize", handleResize);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const ProfileHandelChange = (e) => {
    setfile(URL.createObjectURL(e.target.files[0]));
  };

  console.log(user, "user");
  const [status, setstatus] = useState(false);
  const navigate = useNavigate();

  const { request, loading, error } = useApi((formdata) =>
    apiClient.put("/profile", formdata)
  );
  // useEffect(() => {
  //   const fetch = async () => {
  //     const response = await apiClient.get("/profile");
  //     const data = response.data;
  //     setfile(data);
  //   };
  //   fetch();
  // }, []);
  const handleSubmit = async (e) => {
    e.preventDefault();
    const formdata = new FormData();
    formdata.append("userimage", file);
    const result = await request(formdata);
  };
  return (
    <div>
      <div className="ps-0 ps-md-3">
        <div
          className=""
          style={{
            backgroundColor: "#015A96",
            borderTopLeftRadius: 20,
            borderBottomLeftRadius: 20,
          }}
        >
          {(status || !isMobile) && (
            <div
              className=" sidebar "
              style={{ height: "95vh", overflow: "auto" }}
            >
              <div className="side-bar-content pt-5 d-flex flex-wrap flex-column align-items-center">
                <div className=" profile_img">
                  <div
                    style={{ width: "5rem" }}
                    className=" img pb-2 border border-2 border-top-0 border-end-0 border-start-0 border-white"
                  >
                    <img
                      width="100%"
                      src={file}
                      alt=""
                      className="rounded-circle mw-100"
                    />
                  </div>
                  <input
                    hidden
                    type="file"
                    name=""
                    id="uplod-profile"
                    onChange={ProfileHandelChange}
                  />
                  <label htmlFor="uplod-profile">
                    <FaPlusCircle className="img_icon" />
                  </label>
                </div>
                <div className="sidebar-links">
                  <ul className="list-unstyled sidebar_list">
                    <NavLink
                      className="text-white nav-link"
                      to={"/installeraccount"}
                    >
                      <li
                        className=" m-2 mt-1 p-2"
                        onClick={() => {
                          setstatus(false);
                        }}
                      >
                        <i class="bi bi-person-fill"></i>
                        <span className="ps-1 ">Account</span>
                      </li>
                    </NavLink>

                    <NavLink
                      className="text-white nav-link"
                      to={"/installerrequest"}
                    >
                      <li
                        className="m-2 mt-1 p-2"
                        onClick={() => {
                          setstatus(false);
                          // navigate('/installerrequest')
                        }}
                      >
                        <i className="bi bi-chat-left-fill" />
                        <span className="ps-2 ">Requests</span>
                      </li>
                    </NavLink>

                    <NavLink
                      className="text-white nav-link"
                      to={"/installer-schedule"}
                    >
                      <li
                        className="m-2 mt-1 p-2"
                        onClick={() => {
                          setstatus(false);
                          // navigate('/installer-schedule')
                        }}
                      >
                        <i className="bi bi-calendar-fill" />
                        <span className="ps-2 ">Schedule</span>
                      </li>
                    </NavLink>

                    <NavLink
                      className="text-white nav-link"
                      to={"/installerjob"}
                    >
                      <li
                        className="m-2 mt-1 pt-2 px-1"
                        onClick={() => {
                          setstatus(false);
                          // navigate('/installerjob')
                        }}
                      >
                        {/* <i className="bi bi-camera-fill" />  */}
                        {/* <img src={require("../../src/assets/img/schedule-job-icon.png")} alt="" /> */}
                        <AiFillFormatPainter size={35} />
                        {/* <i className="bi bi-paint" />  */}

                        <span className="ps-1">Jobs</span>
                      </li>
                    </NavLink>

                    <NavLink
                      className="text-white nav-link"
                      to={"/installerpayment"}
                    >
                      <li
                        className="m-2 mt-1 p-2"
                        onClick={() => {
                          setstatus(false);
                          // navigate('/installerpayment')
                        }}
                      >
                        <i className="bi bi-credit-card-fill" />
                        <span className="ps-2 ">Payment</span>
                      </li>
                    </NavLink>

                    <NavLink
                      className="text-white nav-link"
                      to={"/installersetting"}
                    >
                      <li
                        className="setting m-2 mt-1 p-2"
                        onClick={() => {
                          setstatus(false);
                          navigate("/installersetting");
                        }}
                      >
                        <i className="bi bi-gear-fill" />
                        <span className="ps-2 ">Settings</span>
                      </li>
                    </NavLink>
                  </ul>
                </div>
              </div>
            </div>
          )}
          <button
            onClick={() => setstatus(!status)}
            className="open-menu  d-sm-none d-block ms-auto text-white fs-2 border-0 bg-blue rounded-pill p-3 position-absolute top-0 end-0"
          >
            <i className="bi bi-list" />
          </button>
        </div>
      </div>
    </div>
  );
};
